export const Images = {
  logo: '/assets/logo_mini.png'
};
